import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetQuestionmark: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2a10 10 0 110 20 10 10 0 010-20m-2-4a2.5 2.5 0 014.5 1c0 1.5-2.5 2-2.5 4m0 3h.01" />
      </svg>
    </div>
  );
};

export default WidgetQuestionmark;
